import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate } from 'tslib';
import { Component, Mixins } from 'vue-property-decorator';

/**
 * Component used to indicate loading state after connection drop was detected.
 */
var ReconnectLoaderComponent = /** @class */ (function (_super) {
    __extends(ReconnectLoaderComponent, _super);
    function ReconnectLoaderComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReconnectLoaderComponent = __decorate([
        Component({
            name: 'ui-reconnect-loader',
        })
    ], ReconnectLoaderComponent);
    return ReconnectLoaderComponent;
}(Mixins(MagicConfigMixin)));

export default ReconnectLoaderComponent;
